import { z } from "zod";

export const KrijgsmanLoboFerreiraRequestSchema = z.object({
  userGradients: z.array(z.number().positive()).optional(),
});

export type KrijgsmanLoboFerreiraRequest = z.infer<typeof KrijgsmanLoboFerreiraRequestSchema>;
